import { useLayoutEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'
import ScrollToTop from './ScrollToTop'

export default function Layout() {
  const location = useLocation()

  useLayoutEffect(() => {
    const main = document.getElementById('main-content')
    if (!main) return

    document.documentElement.classList.add('motion-enabled')

    main
      .querySelectorAll<HTMLElement>(':scope > section:not(.editorial-hero):not(.page-hero):not(.service-ribbon)')
      .forEach((section) => section.setAttribute('data-reveal', ''))

    const staggerGroups = main.querySelectorAll<HTMLElement>([
      '.section-heading',
      '.intro-grid__heading',
      '.intro-grid__copy',
      '.suite-system__statement',
      '.suite-index',
      '.availability-bridge__inner',
      '.suite-experience__copy',
      '.professional-grid',
      '.directory-grid',
      '.join-section__copy',
      '.join-steps',
      '.gallery-grid',
      '.suite-gallery',
      '.vision-grid',
      '.values-grid',
      '.amenity-grid',
      '.faq-list',
      '.contact-cards',
      '.location-grid__copy',
      '.locations-grid',
    ].join(','))

    staggerGroups.forEach((group) => {
      Array.from(group.children).forEach((child, index) => {
        if (!(child instanceof HTMLElement)) return
        child.setAttribute('data-motion', '')
        child.style.setProperty('--motion-delay', `${Math.min(index % 4, 3) * 55}ms`)
      })
    })

    main
      .querySelectorAll<HTMLElement>([
        '.contact-form',
        '.image-frame',
        '.suite-collage',
        '.waitlist-panel__inner',
        '.final-cta__inner',
      ].join(','))
      .forEach((element) => element.setAttribute('data-motion', ''))

    const elements = Array.from(main.querySelectorAll<HTMLElement>('[data-reveal], [data-motion]'))
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((element) => element.classList.add('is-visible'))
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '0px 0px -4% 0px', threshold: 0.04 },
    )

    elements.forEach((element) => observer.observe(element))
    return () => observer.disconnect()
  }, [location.pathname])

  return (
    <>
      <ScrollToTop />
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
    </>
  )
}
